import React, {
  Fragment,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { Doctor } from "../../resources/Assets";
// Provider
import { AppContext, SET_USER_HEALTH } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import {
  AlertPopup,
  closeLayerFn,
  Container,
  openAlertPopup,
  openLayerFn,
} from "../Layout";
import {
  CardEdit,
  DoctorMessage,
  Food,
  Health,
  HealthInput,
} from "./SM.Layers";

// Temp Images
// import _T_USER from "../../resources/images/user/user_photo_circle.jpg";
import _T_USER_DEFAULT_MALE from "../../resources/images/user/photo_default_img.jpg";
import _T_USER_DEFAULT_FEMALE from "../../resources/images/user/photo_default_img2.jpg";

import {
  PostApi1902,
  PostApi1911,
  PostApi999,
} from "../../modules/network/padoPost";
import { getCookie } from "../../modules/utils/cookie";
import { NativeAction } from "../../modules/utils/HandleWs";
import { userHabit } from "../../modules/utils/UserHabit";
import { ScrollToTop } from "../common/ScrollToTop/ScrollToTop";
import useTitle from "../../modules/hooks/useTitle";

export default props => {
  useTitle("자가건강관리_메인");
  const { auth, mypagecfg, userinfo, cfg, phonecfg, dispatch } =
    useContext(AppContext);

  const [bodyInfo, setBodyInfo] = useState("");
  const [healthInfo, setHealthInfo] = useState("");
  const [cardList, setCardList] = useState();
  const [cardEditList, setCardEditList] = useState();

  const visitBefore = localStorage.getItem("visitBefore");
  const visitUser = localStorage.getItem("visitUser");

  useEffect(() => {
    let date = new Date();
    let year = date.getFullYear();
    let month = new String(date.getMonth() + 1);
    let day = new String(date.getDate());

    if (month.length == 1) {
      month = "0" + month;
    }

    if (day.length == 1) {
      day = "0" + day;
    }
    let expires = year + "" + month + "" + day;

    if (
      (visitBefore && visitBefore != expires) ||
      (visitUser && visitUser != userinfo.userToken)
    ) {
      openLayerFn($(".doctor-message-layer"));
      localStorage.setItem("visitBefore", expires);
      localStorage.setItem("visitUser", userinfo.userToken);
      return;
    }

    if (auth && (!visitBefore || !visitUser)) {
      openLayerFn($(".doctor-message-layer"));
      localStorage.setItem("visitBefore", expires);
      localStorage.setItem("visitUser", userinfo.userToken);
    }
  }, [visitBefore, visitUser]);

  useEffect(() => {
    const cardString = sessionStorage.getItem("cardInfo");
    if (!!cardString) {
      const cardJson = JSON.parse(cardString);
      const cardArray = Object.values(cardJson);
      setCardList([...cardArray]);
    }
  }, []);

  useEffect(() => {
    initView();
  }, [mypagecfg.selfcard]);

  const request1902 = (userinfo, cfg) => {
    PostApi1902(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          setHealthInfo(res.result);

          if (res.result) {
            dispatch({ type: SET_USER_HEALTH, data: res.result });
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const request1911 = (userinfo, cfg, cardType) => {
    PostApi1911(userinfo, cfg, phonecfg, cardType)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          setCardList(res.result);
          const cardJson = { ...res.result };
          const cardString = JSON.stringify(cardJson);
          sessionStorage.setItem("cardInfo", cardString);
        } else {
          openAlertPopup("token error");
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
  const LayerOpen = () => {
    userHabit(phonecfg, "SM100_P03");
    openLayerFn($(".myhealth-cards-layer"));
  };

  useLayoutEffect(() => {
    PostApi999(phonecfg, cfg, userinfo.userToken)
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          if (res.resultList === 1) {
            request1902(userinfo, cfg);
            request1911(userinfo, cfg, "selfcard");
          } else {
            openLayerFn($(".alert-layer-logout"));
            // dispatch({ type: LOG_OUT_SUCCESS });
            // socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {
            //   login: "out",
            //   userToken: "",
            // });
          }
        }
      })
      .catch(err => {});
  }, [mypagecfg.selfcard, phonecfg]);

  useEffect(() => {
    if (healthInfo && props.match.params.param === "1") {
      openLayerFn($(".myhealth-list-layer"));
    }
  }, [healthInfo]);

  useEffect(() => {
    userHabit(phonecfg, "SM100");
    NativeAction(phonecfg, "statusColor", "#7FD2C2");
  }, [phonecfg.version]);

  return (
    <Fragment>
      <ScrollToTop />
      <Container Title="자가건강관리" goToUrl="/" color="green">
        <div className="contents sub">
          <div className="member-info-top">
            <div className="photo-area">
              <span>
                {auth && userinfo.sex === "1" && (
                  <img src={_T_USER_DEFAULT_MALE} alt="" />
                )}
                {auth && userinfo.sex === "2" && (
                  <img src={_T_USER_DEFAULT_FEMALE} alt="" />
                )}
              </span>
            </div>
            <div className="member-name">
              {auth && userinfo ? userinfo.userName : "비회원"}
            </div>
          </div>

          <div className="member-info-contents">
            <div className="memberinfo-wrap">
              {healthInfo ? (
                <BodyInfoBox healthInfo={healthInfo} />
              ) : (
                <EmptyBox />
              )}
            </div>
            <a href={void 0} className="btn-info-toggle"></a>
          </div>

          <div className="myhealth-state-container">
            {mypagecfg &&
              cardList &&
              cardList.map((m, i) =>
                // (m.cardId === "BP" && (m.mndtYn === "Y" || mypagecfg.selfcard.BP.cardYn === "Y")) ? <BpCard key={i} cardNm={m.cardNm} column1={m.column1} column2={m.column2} date1={m.date1} date2={m.date2} date3={m.date3} date4={m.date4} /> :
                // (m.cardId === "BS" && (m.mndtYn === "Y" || mypagecfg.selfcard.BS.cardYn === "Y")) ? <BsCard key={i} cardNm={m.cardNm} column1={m.column1} column2={m.column2} column3={m.column3} date1={m.date1} date2={m.date2} date3={m.date3} date4={m.date4} /> :
                // (m.cardId === "BMI" && (m.mndtYn === "Y" || mypagecfg.selfcard.BMI.cardYn === "Y")) ? <BmiCard key={i} cardNm={m.cardNm} column1={m.column1} column2={m.column2} date1={m.date1} date2={m.date2} date3={m.date3} date4={m.date4} /> :
                m.cardId === "BP" && mypagecfg.selfcard.BP.cardYn === "Y" ? (
                  <BpCard
                    key={i}
                    cardNm={m.cardNm}
                    column1={m.column1}
                    column2={m.column2}
                    date1={m.date1}
                    date2={m.date2}
                    date3={m.date3}
                    date4={m.date4}
                  />
                ) : m.cardId === "BS" &&
                  mypagecfg.selfcard.BS.cardYn === "Y" ? (
                  <BsCard
                    key={i}
                    cardNm={m.cardNm}
                    column1={m.column1}
                    column2={m.column2}
                    column3={m.column3}
                    date1={m.date1}
                    date2={m.date2}
                    date3={m.date3}
                    date4={m.date4}
                  />
                ) : // (m.cardId === "BMI" && (mypagecfg.selfcard.BMI.cardYn === "Y")) ? <BmiCard key={i} cardNm={m.cardNm} column1={m.column1} column2={m.column2} date1={m.date1} date2={m.date2} date3={m.date3} date4={m.date4} /> :
                // (m.cardId === "FOOD" && mypagecfg.selfcard.FOOD.cardYn === "Y" )? <DietCard key={i} cardNm={m.cardNm} column1={m.column1} column2={m.column2} date1={m.date1} date2={m.date2} date3={m.date3} date4={m.date4} /> :
                // (m.cardId === "HISTORY" && mypagecfg.selfcard.HISTORY.cardYn === "Y" )? <HistCard key={i} cardNm={m.cardNm} column1={m.column1} column2={m.column2} date1={m.date1} date2={m.date2} date3={m.date3} date4={m.date4} /> :
                // (m.cardId === "ACTIVE" && mypagecfg.selfcard.ACTIVE.cardYn === "Y" ) ? <ExCard key={i} cardNm={m.cardNm} column1={m.column1} column2={m.column2} date1={m.date1} date2={m.date2} date3={m.date3} date4={m.date4} /> :

                m.cardId === "ALLERGY" &&
                  (m.mndtYn === "Y" ||
                    mypagecfg.selfcard.ALLERGY.cardYn === "Y") ? (
                  <AllergyCard
                    key={i}
                    cardNm={m.cardNm}
                    column1={m.column1}
                    column2={m.column2}
                    date1={m.date1}
                    date2={m.date2}
                    date3={m.date3}
                    date4={m.date4}
                  />
                ) : (
                  m.cardId === "STUDYRESULT" && (
                    <InptRsltCard
                      key={i}
                      cardNm={m.cardNm}
                      column1={m.column1}
                      column2={m.column2}
                      date1={m.date1}
                      date2={m.date2}
                      date3={m.date3}
                      date4={m.date4}
                    />
                  )
                )
              )}
          </div>

          <div className="myhealth-btn-addlist">
            <a
              onClick={LayerOpen}
              className="btn-circleplus btn-mycardadd-layer">
              <i></i>
              <p>목록추가</p>
            </a>
          </div>
        </div>
      </Container>
      {auth && (
        <DoctorMessage
          image={userinfo.sex === "1" ? Doctor.male.laugh : Doctor.female.laugh}
          message="MAIN"
        />
      )}
      <HealthInput healthInfo={healthInfo} request1902={request1902} />
      {healthInfo && <Health healthInfo={healthInfo} />}
      <Food />
      <CardEdit request1911={request1911} />
      <AlertPopup />
      {/* <Allergy mode='popup'/> */}
    </Fragment>
  );
};

const initView = () => {
  //주치의 메세지 띄우기 (조건에 맞으면)
  // openLayerFn($(".doctor-message-layer"));

  //주치의 메세지 닫기(확인버튼)
  $(".close-doctor-message").click(function () {
    closeLayerFn($(".doctor-message-layer"));

    // 오늘 하루 안나오게
  });

  //식단 길게 누르기
  $(".circle-icons-info .longpress").on("long-press", function () {
    openLayerFn($(".main-foodmenu-layer"));
  });

  //신체정보 토글(슬라이드)
  $("a.btn-info-toggle").click(function () {
    $(this).toggleClass("dw");
    $(".memberinfo-wrap").slideToggle("fast");

    $(".circle-icons-info > div").removeClass("on");
  });

  ////건강정보입력 step1~3 레이어
  //레이어 열기
  $(".btn-openhealthlayer").click(function () {
    openLayerFn($(".health-input-layer"));
  });

  //다음
  $(".health-input-layer .btn-next").click(function () {
    var currentPaIndex = $(this).closest(".step-section").index();
    $(".health-input-layer .health-input-contain > div").hide();
    $(".health-input-layer .health-input-contain > div")
      .eq(currentPaIndex + 1)
      .show();
  });
  //이전
  $(".health-input-layer .btn-prev").click(function () {
    var currentPaIndex = $(this).closest(".step-section").index();
    $(".health-input-layer .health-input-contain > div").hide();
    $(".health-input-layer .health-input-contain > div")
      .eq(currentPaIndex - 1)
      .show();
  });
  //취소, 확인 (레이어 닫기);
  $(".health-input-layer .btn-cancel , .health-input-layer .btn-apply").click(
    function () {
      closeLayerFn($(".health-input-layer"));
      $(".health-input-layer .health-input-contain > div").hide();
      $(".health-input-layer .health-input-contain > div").eq(0).show();
    }
  );

  ////MY 건강정보 레이어
  //열기(건강정보이력 버튼)
  $(".btn-open-myhealth").click(function () {
    openLayerFn($(".myhealth-list-layer"));
  });

  ////목록관리(카드 추가)
  //닫기(X버튼, 목록 저장)
  $(
    ".myhealth-cards-layer .btn-setlayer-close , .myhealth-cards-layer .btn-mycard-save"
  ).click(function () {
    closeLayerFn($(".myhealth-cards-layer"));
  });

  //식단 레이어 닫기
  $(".main-foodmenu-layer .tbns-area a").click(function () {
    closeLayerFn($(".main-foodmenu-layer"));
  });
};

const EmptyBox = () => {
  return (
    <div className="empty-graybox">
      <a href={void 0} className="btn-openhealthlayer">
        <span></span>
        <p>신체정보를 입력해 주세요.</p>
      </a>
    </div>
  );
};

const BodyInfoBox = props => {
  const { healthInfo } = props;
  const { userinfo, mypagecfg, auth, phonecfg } = useContext(AppContext);
  useEffect(() => {
    let tooltipDispp;
    //아이콘 탭
    $(".circle-icons-info > div").click(function () {
      clearTimeout(tooltipDispp);
      if (!$(this).hasClass("on")) {
        $(".circle-icons-info > div").removeClass("on");
        $(this).addClass("on");
      }
      tooltipDisappear();
    });

    const tooltipDisappear = () => {
      tooltipDispp = setTimeout(function () {
        $(".circle-icons-info > div").removeClass("on");
        clearTimeout(tooltipDispp);
      }, 3000);
    };
  }, []);

  const checkDataValue = (param, className) => {
    if (param.find(e => e != "N")) {
      return className;
    } else {
      return className + " dis";
    }
  };

  const openMyHealth = () => {
    userHabit(phonecfg, "SM100_P01");
    openLayerFn($(".myhealth-list-layer"));
  };

  return (
    <div className="body-info-box">
      <div className="body-check">
        {userinfo.sex === "1" && <span className="m3"></span>}
        {userinfo.sex === "2" && <span className="w3"></span>}
        {/* 체형별 클래스명: 홀쭉 ~ 뚱뚱 순서...
                여자 체형별 : w1, w2, w3, w4
                남자 체형별 : m1, m2, m3, m4 */}
      </div>
      <div className="info-list">
        <div className="text-info">
          <div>
            <span>성별</span>
            <p>
              <i
                className={
                  getCookie("isAuthOk") != 9
                    ? userinfo.sex === "1"
                      ? "ic-male"
                      : "ic-female"
                    : ""
                }></i>

              {getCookie("isAuthOk") != 9
                ? userinfo.sex === "1"
                  ? "남"
                  : "여"
                : "미등록"}
            </p>
          </div>
          <div>
            <span>혈액형</span>
            <p>
              {auth ? healthInfo.blodTypeDtl : ""}{" "}
              {auth ? healthInfo.blodType : ""}
            </p>
          </div>
          <div>
            <span>BMI</span>
            <p>
              {auth
                ? healthInfo.hght && healthInfo.wght
                  ? (
                      (healthInfo.wght / (healthInfo.hght * healthInfo.hght)) *
                      10000
                    ).toFixed(2)
                  : "미등록"
                : "미등록"}
            </p>
          </div>
        </div>
        <div className="circle-icons-info">
          <div>
            <span
              className={
                mypagecfg.selfcard.BP.cardYn === "Y" ? "c1" : "c1 dis"
              }></span>
            <div className="tooltip_rvs">
              {mypagecfg.selfcard.BP.cardYn === "Y" ? "혈압관리중" : "혈압"}
            </div>
          </div>
          <div>
            <span
              className={
                mypagecfg.selfcard.BS.cardYn === "Y" ? "c2" : "c2 dis"
              }></span>
            <div className="tooltip">
              {mypagecfg.selfcard.BP.cardYn === "Y" ? "혈당관리중" : "혈당"}
            </div>
          </div>
          <div className="longpress">
            <span
              className={
                mypagecfg.selfcard.FOOD.cardYn === "Y" ? "c3" : "c3 dis"
              }></span>
            <div className="tooltip">
              {mypagecfg.selfcard.FOOD.cardYn === "Y" ? "식단관리중" : "식단"}
            </div>
          </div>
          <div>
            <span
              className={
                auth &&
                checkDataValue(
                  [
                    healthInfo.hpttsBVcnt,
                    healthInfo.hpttsAVcnt,
                    healthInfo.pnmn13Vcnt,
                    healthInfo.pnmn23Vcnt,
                    healthInfo.hrpztVcnt,
                    healthInfo.infzVcnt,
                    healthInfo.ttnsVcnt,
                    healthInfo.TdapVcnt,
                    healthInfo.crvclCncrVcnt,
                  ],
                  "c4"
                )
              }></span>
            <div className="tooltip">예방접종</div>
          </div>
          <div>
            <span
              className={
                auth &&
                checkDataValue(
                  [
                    healthInfo.hpttsATest,
                    healthInfo.hpttsBTest,
                    healthInfo.hpttsCTest,
                  ],
                  "c5"
                )
              }></span>
            <div className="tooltip">항체검사</div>
          </div>
          <div>
            <span
              className={
                mypagecfg.selfcard.ALLERGY.cardYn === "Y" ? "c6" : "c6 dis"
              }></span>
            <div className="tooltip">
              {mypagecfg.selfcard.ALLERGY.cardYn === "Y"
                ? "알레르기관리중"
                : "알레르기"}
            </div>
          </div>
        </div>
      </div>
      <div className="btns-two">
        <a onClick={() => openMyHealth()} className="btn-open-myhealth">
          <i></i>MY 건강정보
        </a>
      </div>
    </div>
  );
};

const BpCard = props => {
  const { cardNm, column1, column2, date1, date2, date3, date4 } = props;
  return (
    <div className="card long green" onClick={e => _O.Open("/sm/bp/input")}>
      <div>
        <a href={void 0}>
          <div className="title">
            <i className="c1"></i> {cardNm}
          </div>

          <div className="in-value-info">
            <div>
              <span>수축기</span>
              <p>
                {column1}
                <em> mmgh</em>
              </p>
            </div>
            <div>
              <span>이완기</span>
              <p>
                {column2}
                <em> mmgh</em>
              </p>
            </div>
          </div>
        </a>

        <div className="date-time">
          {date1 && date2 && date4 && date1 + " (" + date2 + ") " + date4}
          <a></a>
        </div>
      </div>
    </div>
  );
};

const BmiCard = props => {
  const { cardNm, column1, column2, date1, date2, date3, date4 } = props;
  return (
    <div className="card long blue" onClick={e => _O.Open("/sm/bmi/rcnt")}>
      <div>
        <a>
          <div className="title">
            <i className="c2"></i> {cardNm}
          </div>

          <div className="in-value-info">
            <div>
              <span></span>
              <p></p>
            </div>
            <div>
              <span></span>
              <p>
                35.5<em> kg/㎡</em>
              </p>
            </div>
          </div>
        </a>

        <div className="date-time">
          {date1 && date2 && date4 && date1 + " (" + date2 + ") " + date4}
          <a></a>
        </div>
      </div>
    </div>
  );
};

const BsCard = props => {
  const { cardNm, column1, column2, column3, date1, date2, date3, date4 } =
    props;
  return (
    <div className="card long pink" onClick={e => _O.Open("/sm/bs/input")}>
      <div>
        <a>
          <div className="title">
            <i className="c3"></i> {cardNm}
          </div>

          <div className="in-value-info">
            <div>
              <span></span>
              <p></p>
            </div>
            <div>
              <span></span>
              <p>
                {column1}
                <em> {column3}</em>
              </p>
            </div>
          </div>
        </a>

        <div className="date-time">
          {date1 && date2 && date4 && date1 + " (" + date2 + ") " + date4}
          <a></a>
        </div>
      </div>
    </div>
  );
};

const InptRsltCard = props => {
  const { cardNm, column1, column2, column3, date1, date2, date3, date4 } =
    props;
  return (
    <div className="card long yellow" onClick={e => _O.Open("/sm/isptResult")}>
      <div>
        <a>
          <div className="title">
            <i className="c9"></i> {cardNm}
          </div>

          <div className="aday-meal">
            <div>
              <span className="on" style={{ width: "100%" }}>
                <i className="cm1"></i>당화혈색소
              </span>
            </div>
          </div>
        </a>

        <div className="date-time">
          {date1 && date2 && date4 && date1 + " (" + date2 + ") " + date4}
          <a></a>
        </div>
      </div>
    </div>
  );
};

const DietCard = props => {
  const { cardNm, column1, column2, date1, date2, date3, date4 } = props;
  return (
    <div className="card long" onClick={e => _O.Open("/sm/addDiet")}>
      <div>
        <a>
          <div className="title">
            <i className="c4"></i> 식단
          </div>

          <div className="aday-meal">
            <div>
              <span className="on">아침</span>
            </div>
            <div>
              <span className="on">점심</span>
            </div>
            <div>
              <span>저녁</span>
            </div>
          </div>
        </a>

        <div className="date-time">
          {date1 && date2 && date4 && date1 + " (" + date2 + ") " + date4}
        </div>
      </div>
    </div>
  );
};

const HistCard = props => {
  const { cardNm, column1, column2, date1, date2, date3, date4 } = props;
  return (
    <div className="card long">
      <div>
        <a href={void 0}>
          <div className="title">
            <i className="c5"></i> 과거이력
          </div>

          <div className="aday-meal pur">
            <div>
              <span className="on">
                <i className="cm1"></i>백신접종
              </span>
            </div>
            <div>
              <span className="on">
                <i className="cm2"></i>항체검사
              </span>
            </div>
            <div>
              <span>
                <i className="cm3"></i>알레르기
              </span>
            </div>
          </div>
        </a>

        <div className="date-time">
          {date1 && date2 && date4 && date1 + " (" + date2 + ") " + date4}
        </div>
      </div>
    </div>
  );
};

const ExCard = props => {
  const { cardNm, column1, column2, date1, date2, date3, date4 } = props;
  return (
    <div className="card long">
      <div>
        <a onClick={e => _O.Open("/sm/exercise/rcnt")}>
          <div className="title">
            <i className="c6"></i> 운동
          </div>
        </a>

        <div className="date-time">
          {date1 && date2 && date4 && date1 + " (" + date2 + ") " + date4}
        </div>
      </div>
    </div>
  );
};

const AllergyCard = props => {
  const { cardNm, column1, column2, date1, date2, date3, date4 } = props;
  const [active0, setActive0] = useState("");
  const [active1, setActive1] = useState("");
  const [active2, setActive2] = useState("");
  const [active9, setActive9] = useState("");

  useEffect(() => {
    if (column1) {
      if (column1.indexOf("0") > -1) {
        setActive0("on");
      }
      if (column1.indexOf("1") > -1) {
        setActive1("on");
      }
      if (column1.indexOf("2") > -1) {
        setActive2("on");
      }
      if (column1.indexOf("9") > -1) {
        setActive9("on");
      }
    }
  }, []);
  return (
    <div className="card long" onClick={e => _O.Open("/sm/allergy")}>
      <div>
        <a>
          <div className="title">
            <i className="c7"></i> 알레르기
          </div>

          <div className="aday-meal2 pur">
            <AllergyCardSub title="약품" active={active0} />
            <AllergyCardSub title="주의약품" active={active2} />
            <AllergyCardSub title="식품" active={active1} />
            <AllergyCardSub title="기타" active={active9} />
          </div>
        </a>

        <div className="date-time">
          {date1 && date2 && date4 && date1 + " (" + date2 + ") " + date4}
          <a></a>
        </div>
      </div>
    </div>
  );
};

export const AllergyCardSub = props => {
  const { title, active } = props;
  return (
    <div>
      <span className={active === "on" ? "on" : ""}>
        <i className={active === "on" ? "chk" : ""}></i>
        <p>{title}</p>
      </span>
    </div>
  );
};
